export const generateId = () => `records-${Date.now()}`;
